<template>
    <div class="obligationsMovements">
        <b-tabs
            size="is-medium"
            :animated="false"
            type="is-boxed naked"
            class="container"
        >
            <b-tab-item label="Obligaciones" class="pt-5">
                <SectionHeader
                    title="El orden financiero comienza manteniendo tus obligaciones al día"
                />
                <slot name="obligations"></slot>
            </b-tab-item>
            <b-tab-item label="Bancos" class="pt-5">
                <slot name="stament"></slot>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
import SectionHeader from "@/components/sectionHeader/SectionHeader";

export default {
    name: "DashboardMainTabs",
    components: {
        SectionHeader,
    },
};
</script>
